import { useEffect, DependencyList } from 'react';

export const useSetDocumentTitle = (
  newTitle: string,
  deps: DependencyList = [],
) => {
  useEffect(() => {
    document.title = `${newTitle} - Arbeidslivsportalen`;
  }, [newTitle, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
};
